<template>
  <div class="ac-item" :class="[isActive ? 'ac-active' : '']" @click="toggleActive">
    <h5 class="ac-title"><i :class="getClasses()"></i> {{title}}</h5>
    <div class="ac-content" :class="[isActive ? 'showed' : 'hidden']">
      <div class="list-group">
        <div class="list-group-item" v-for="category in categories" :key="category.id">
          <router-link class="parent-link" :to="{name:'home', params:{type: slug, slug: category.slug}}" v-on:click.native="goToDataView">
            {{category.name}}
            <span class="badge">{{category.count}}</span>
          </router-link>
          <div class="childrens-area" v-if="category.childrens">
            <router-link class="children-link" :to="{name:'home', params:{type: slug, slug: child.slug}}" v-for="child in category.childrens" :key="child.id" v-on:click.native="goToDataView">
              {{child.name}}
              <span class="badge">{{child.count}}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import scrollTo from 'vue-scrollto';

  export default {
    name: 'navitem',
    props: ['title', 'icon', 'categories', 'slug', 'childrens'],
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      goToDataView() {
        scrollTo.scrollTo('#view-data', 500);
      },
      getClasses() {
        return `fa ${this.icon}`;
      },
      toggleActive(event) {
        if (event.target.tagName === 'H5') {
          this.isActive = !this.isActive;
        }
      },
    },
  };
</script>

<style>
  #sidebar .showed {
    display: block;
  }

  #sidebar .hidden {
    display: none;
  }

  #sidebar .parent-link,
  #sidebar .children-link{
    display: block;
    width: 100%;
  }

  #sidebar .children-link{
    padding-top: 10px;
  }

  #sidebar .parent-link .badge,
  #sidebar .children-link .badge {
    float: right;
  }

  #sidebar .childrens-area{
    margin-left: 1rem;
  }


</style>



// WEBPACK FOOTER //
// NavItem.vue?3d69dfcb